module.exports = __webpack_public_path__ + "img/xiangmu6.1d7fb140.png";